// The server refuses a client_mutation_id that already names a different
// entry (#672 review). The form keeps its key after an error so a lost
// response can be retried safely; on this refusal the key must be dropped,
// otherwise every resubmit of the edited draft is refused again.
export const TA_MUTATION_KEY_CONFLICT = 'ta_mutation_key_conflict'

// Releases ONLY the key, on the draft as it is now: the fields stay editable
// while a submit is in flight, so restoring the submitted payload would throw
// away whatever the TA typed during the save (#672 review round 2).
export function releaseConflictedMutationKey(result, setDraft) {
  if (result?.code !== TA_MUTATION_KEY_CONFLICT) return false
  setDraft((current) => ({ ...current, client_mutation_id: '' }))
  return true
}
